import React, { useCallback } from 'react';
import { useLingui } from '@lingui/react/macro';
import { Outlet, useMatch, useNavigate } from 'react-router-dom';
import UDButton from 'ud-ui/components/button';
import { StageGridTab } from 'modules/championship/domain/enums/stage-grid-tab';
import { StageV2 } from 'modules/championship/domain/interfaces/stage';
import { Pages } from 'modules/navigation/domain/enums/pages';

interface StageStandingTabsProps {
  stage: StageV2;
}

/**
 * Переключатель «Таблица / Шахматка». Layout-роут: сами таблицы рендерит `<Outlet/>`,
 * поэтому таб-бар не перемонтируется при переключении.
 */
const StageStandingTabs = ({ stage }: StageStandingTabsProps) => {
  const { t } = useLingui();
  const navigate = useNavigate();
  const isMatrix = Boolean(useMatch(Pages.CHAMPIONSHIPS.STEPS.GRID_MATRIX));

  const openTab = useCallback(
    (tab: StageGridTab) => () => {
      navigate(Pages.CHAMPIONSHIPS.STEPS.builders.grid(stage.championshipId, stage.id, tab));
    },
    [navigate, stage.championshipId, stage.id],
  );

  return (
    <div className="flex flex-col gap-3">
      <div className="flex gap-2">
        <UDButton variant={isMatrix ? 'light' : 'primary'} onClick={openTab(StageGridTab.STANDING)}>
          {t`Таблица`}
        </UDButton>
        <UDButton variant={isMatrix ? 'primary' : 'light'} onClick={openTab(StageGridTab.MATRIX)}>
          {t`Шахматка`}
        </UDButton>
      </div>

      <Outlet />
    </div>
  );
};

export default StageStandingTabs;
